import React from 'react';

export default (props)=>{
	
	return (
		<div className="col-xs-12 data-modal">
			<div className="col-xs-12 form-group">
				<div className="col-xs-12">
					<span className="span-min">{props.title}</span>
					<input type="text" name="medical_name" id="medical_name"
						value={props.medical.name} className="form-control" disabled
						onChange={(e)=>props.handleChange(props.name, 'name', e.target.value)} />
				</div>
			</div>
			<div className="col-xs-12 form-group">
				<div className="col-xs-12">
					<span className="span-min">Comentario: </span>
					<textarea name="comment" id="comment" value={props.medical.comment}
						style={{height:"100px",width:"100%",resize:"none"}}
						className="form-control" required
						onChange={(e)=>props.handleChange(props.name, 'comment', e.target.value)}></textarea>
				</div>
			</div>
		</div>
	);
}